/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { Collapse, List, Menu } from '@mui/material'
import { DrawerMainMenuItem } from '@components/systems/drawerMenu/DrawerMainMenuItem'

import { useAppSelector, MenuType } from '@redux/index'
import { grey } from '@mui/material/colors'

interface PropsType {
	menu: MenuType
	anchorEl: any
	isOpenMainMenu: boolean
	onCloseSubmenu: () => void
}

export const DrawerMainMenuList = (props: PropsType) => {
	// redux state
	const isOpenDrawer: boolean = useAppSelector(state => state.config.isOpenDrawer)

	const onIsOpenSubmenu = React.useCallback(() => {
		props.onCloseSubmenu()
	}, [])

	return (
		<>
			{props.menu.children !== undefined ? (
				isOpenDrawer ? (
					<Collapse in={props.isOpenMainMenu} timeout="auto" unmountOnExit>
						<List component="div" disablePadding css={{ left: '1.5rem' }}>
							{props.menu.children.map((aMenu: MenuType) => (
								<DrawerMainMenuItem
									key={`${props.menu.id}-${aMenu.id}`}
									menu={aMenu}
									isFirstDepth={false}
								/>
							))}
						</List>
						<View css={style} />
					</Collapse>
				) : (
					<Menu
						id={`group_${props.menu.id}_menu`}
						anchorEl={props.anchorEl}
						open={props.isOpenMainMenu}
						onClose={onIsOpenSubmenu}
						MenuListProps={{
							'aria-labelledby': `group_${props.menu.id}_button`,
						}}
					>
						{props.menu.children.map((aMenu: MenuType) => (
							<DrawerMainMenuItem
								key={`${props.menu.id}-${aMenu.id}`}
								menu={aMenu}
								isFirstDepth={false}
							/>
						))}
					</Menu>
				)
			) : null}
		</>
	)
}

const style = css({
	position: 'absolute',
	width: 1,
	height: 'calc(100% - 2.5rem)',
	border: `1px solid ${grey[300]}`,
	top: '2.5rem',
	left: '1.5rem',
})
